<button
  #button
  class="checkin__btn checkin__btn--secondary"
  [ngClass]="customClass"
  [disabled]="disabled">
  {{ text | translate:translateParams }}
</button>
